import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import TinyInput from '@src/components/tiny-input';
import VerificationModalStore from './store';

const styles = require('./index.less');

const VerificationModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={styles.panel} aria-label="账号验证弹窗">
        <button className={styles.close} type="button" aria-label="关闭" onClick={store.onClickClose}>
          <span>关闭</span>
        </button>
        <div className={styles.surface}>
          <div className={styles.form}>
            <label>
              <span>身份证：</span>
              <TinyInput store={store.idNumberInputStore} maxLength={18} placeholder="请输入身份证号码" />
            </label>
            <label>
              <span>绑定手机：</span>
              <input value={store.phoneDisplay} disabled />
            </label>
            <label>
              <span>验证码：</span>
              <TinyInput store={store.codeInputStore} className={styles.codeInput} maxLength={6} placeholder="请输入验证码" />
              <button className={styles.codeButton} type="button" disabled={store.isSendingCode || store.countdown > 0} onClick={() => store.requestCode()}>
                {store.countdown > 0 ? `${store.countdown}秒` : store.isSendingCode ? '发送中' : '获取验证码'}
              </button>
            </label>
            <p>同1个绑定身份证或绑定手机号下仅可激活1个账号。填写后请确认当前账号与绑定信息无误。</p>
          </div>
          <div className={styles.envelope} />
          <button className={styles.confirm} type="button" disabled={store.isSubmitting} onClick={() => store.submitReservation()}>
            <span>{store.isSubmitting ? '验证中' : '验证'}</span>
          </button>
        </div>
      </section>
    </ModalContainer>
  );
};

export default wrapStore(VerificationModal, VerificationModalStore);
